module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-Sg-film-white.5060be2.png";